import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useGetTermsAndConditionsQuery } from '../../apis/cmsApi/cms.hooks.api';
import { BaseLayout } from '../../components/Layout/Layout';
import { useBack } from '../../hooks/useBack';
import { useLanguage } from '../../locale/useLanguage';

type TermsAndConditionsViewProps = {};

export const TermsAndConditionsView: React.FC<
  TermsAndConditionsViewProps
> = () => {
  const languageSettings = useLanguage();
  const t = languageSettings[0];
  const locale = languageSettings[2];
  const back = useBack();

  const { data: termsAndConditions } = useGetTermsAndConditionsQuery({
    locale,
  });

  return (
    <BaseLayout
      title={t('pageTitles.termsAndConditions')}
      hasBack
      hasViewportHeight
      onBackClick={back}
    >
      {termsAndConditions && (
        <ReactMarkdown>{termsAndConditions.content}</ReactMarkdown>
      )}
    </BaseLayout>
  );
};
